export default __webpack_public_path__ + "static/media/graphicon-3.5cd75252.png";